import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "react-axios";

import { useUser } from "~/Context/userContext";
import { urlMessageBoardTopicSetTracker } from "~/api/getMessageBoard";

import MessageBoardTopicContainer from "../../Containers/MessageBoardTopicContainer";
import TrackPage from "../Track/TrackPage";
import MessageBoardTopic from "./MessageBoardTopic";

import "../Track/TrackPage.less";

const MessageBoardHeader = () => {
  return (
    <div className="totd-md-topic-header main-tab-header">
      <h2>
        <FontAwesomeIcon icon="comments" className="comments fa mr fa-comments" />
        Message Board Topic
      </h2>
    </div>
  );
};

const MessageBoardTopicPage = ({ match }) => {
  const { state: userState } = useUser();
  const topicId = parseInt(match.params.id, 10);

  useEffect(() => {
    if (userState.loaded && userState.loggedin && userState.isChim && userState.user) {
      const chimDir = userState.user.dir;
      axios.post(urlMessageBoardTopicSetTracker(topicId, chimDir));
    }
  }, [userState.loaded]);

  return (
    <MessageBoardTopicContainer
      topicId={topicId}
      render={({ topic, loading }) => (
        <div>
          <MessageBoardHeader />
          {(topic.totd_id === 0 || topic.totd_id === '0') ? (
            <div>
              <MessageBoardTopic topic={topic} loading={loading} />
            </div>
          ) : (
            <div className="totd-mb-track-wrapper">
              <TrackPage match={{ params: { trackId: topic.totd_id } }} />
            </div>
          )}
        </div>
      )}
    />
  );
};

export default MessageBoardTopicPage;
